import { FC } from 'react';
import cx from 'classnames/bind';

import LandScapeIcon from '@/assets/landscape.svg';

import styles from './LandScape.module.scss';

const cn = cx.bind(styles);

const LandScape: FC = () => (
  <div className={cn('container')}>
    <div className={cn('wrapper')}>
      <img className={cn('img')} src={LandScapeIcon} alt="landScape" />
      <span className={cn('text')}>
        Поверните телефон, чтобы начать активность
      </span>
    </div>
  </div>
);

export default LandScape;
